//import React, { useState, useEffect } from 'react';
//import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

//const DashboardChart = () => {
//    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

//    useEffect(() => {
//        const handleResize = () => setWindowWidth(window.innerWidth);
//        window.addEventListener('resize', handleResize);
//        return () => window.removeEventListener('resize', handleResize);
//    }, []);

//    const data = [
//        { name: 'Jan', cumulativeBalance: 2000, reportBaseline: 25000 },
//        { name: 'Feb', cumulativeBalance: 5000, reportBaseline: 27000 },
//        { name: 'Mar', cumulativeBalance: 10000, reportBaseline: 28000 },
//        { name: 'Apr', cumulativeBalance: 15000, reportBaseline: 30000 },
//        { name: 'May', cumulativeBalance: 20000, reportBaseline: 32000 },
//        { name: 'Jun', cumulativeBalance: 25000, reportBaseline: 35000 },
//        { name: 'Jul', cumulativeBalance: 30000, reportBaseline: 37000 },
//        { name: 'Aug', cumulativeBalance: 35000, reportBaseline: 40000 },
//        { name: 'Sep', cumulativeBalance: 38000, reportBaseline: 42000 },
//        { name: 'Oct', cumulativeBalance: 42000, reportBaseline: 45000 },
//        { name: 'Nov', cumulativeBalance: 45000, reportBaseline: 48000 },
//        { name: 'Dec', cumulativeBalance: 48000, reportBaseline: 50000 },
//    ];

//    // Always show all data points
//    const displayData = data;

//    // Adaptive margins based on screen size
//    const margin = {
//        top: 10,
//        right: windowWidth < 640 ? 10 : 30,
//        left: windowWidth < 640 ? 5 : 20,
//        bottom: windowWidth < 640 ? 15 : 5,
//    };

//    // Custom tooltip to ensure it's readable on small screens
//    const CustomTooltip = ({ active, payload, label }) => {
//        if (active && payload && payload.length) {
//            return (
//                <div className="bg-white p-2 border border-gray-200 shadow-md rounded text-xs sm:text-sm">
//                    <p className="font-semibold">{label}</p>
//                    {payload.map((entry, index) => (
//                        <p key={index} style={{ color: entry.color }}>
//                            {entry.name}: ${entry.value.toLocaleString()}
//                        </p>
//                    ))}
//                </div>
//            );
//        }
//        return null;
//    };

//    return (
//        <div className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px]">
//            <ResponsiveContainer width="100%" height="100%">
//                <BarChart
//                    data={displayData}
//                    margin={margin}
//                    barGap={windowWidth < 640 ? 2 : 4}
//                    barCategoryGap={windowWidth < 640 ? 8 : 25}
//                    barSize={windowWidth < 640 ? 10 : 19}
//                >
//                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//                    <XAxis
//                        dataKey="name"
//                        tick={{
//                            fontSize: windowWidth < 640 ? 9 : 12,
//                            angle: windowWidth < 640 ? -45 : 0,
//                            textAnchor: windowWidth < 640 ? 'end' : 'middle'
//                        }}
//                        height={windowWidth < 640 ? 60 : 30}
//                        tickMargin={windowWidth < 640 ? 10 : 5}
//                    />
//                    <YAxis
//                        tick={{ fontSize: windowWidth < 640 ? 10 : 12 }}
//                        tickFormatter={(value) => windowWidth < 640 ? `${value / 1000}k` : `$${value.toLocaleString()}`}
//                        width={windowWidth < 640 ? 35 : 60}
//                    />
//                    <Tooltip content={<CustomTooltip />} />
//                    <Legend
//                        wrapperStyle={{
//                            fontSize: windowWidth < 640 ? 10 : 12,
//                            paddingTop: 40
//                        }}
//                    />
//                    <Bar dataKey="cumulativeBalance" fill="#4F86C6" name="Cumulative Balance" />
//                    <Bar dataKey="reportBaseline" fill="#E97451" name="Report Baseline" />
//                </BarChart>
//            </ResponsiveContainer>
//        </div>
//    );
//};

//export default DashboardChart;

import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useSelector } from "react-redux";
import useAxiosInstance from '../../../services/useAxiosInstance';

const DashboardChart = ({ roleId }) => {
    const axiosInstance = useAxiosInstance();
    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const communityId = useSelector((state) => state.auth.communityId);
    const clientId = useSelector((state) => state.auth.clientId);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Fetch role-based data
    useEffect(() => {
        const fetchChartData = async () => {
            setLoading(true);
            setError(null);

            try {
                if (roleId === 1000) {
                    await fetchSuperadminFinancialData();
                } else if (roleId === 1001 || roleId === 1002) {
                    await fetchCommunityFinancialData();
                } else if (roleId === 1004 || roleId === 1005) {
                    await fetchSalesFinancialData();
                } else {
                    // User role shouldn't see this component, but fallback
                    setFallbackData();
                }
            } catch (error) {
                console.error('Error fetching chart data:', error);
                setError('Failed to load financial data');
                setFallbackData();
            } finally {
                setLoading(false);
            }
        };

        if (roleId) {
            fetchChartData();
        }
    }, [roleId, communityId, clientId]);

    // Superadmin - System-wide financial data
    const fetchSuperadminFinancialData = async () => {
        try {
            const response = await axiosInstance.get('/api/admin/financial/monthly-summary');

            // Transform API data or use fallback if endpoint doesn't exist
            const data = response.data?.months || [
                { name: 'Jan', systemRevenue: 120000, totalExpenses: 80000, netProfit: 40000 },
                { name: 'Feb', systemRevenue: 135000, totalExpenses: 85000, netProfit: 50000 },
                { name: 'Mar', systemRevenue: 142000, totalExpenses: 88000, netProfit: 54000 },
                { name: 'Apr', systemRevenue: 158000, totalExpenses: 92000, netProfit: 66000 },
                { name: 'May', systemRevenue: 165000, totalExpenses: 95000, netProfit: 70000 },
                { name: 'Jun', systemRevenue: 172000, totalExpenses: 98000, netProfit: 74000 },
                { name: 'Jul', systemRevenue: 185000, totalExpenses: 102000, netProfit: 83000 },
                { name: 'Aug', systemRevenue: 192000, totalExpenses: 105000, netProfit: 87000 },
                { name: 'Sep', systemRevenue: 198000, totalExpenses: 108000, netProfit: 90000 },
                { name: 'Oct', systemRevenue: 205000, totalExpenses: 112000, netProfit: 93000 },
                { name: 'Nov', systemRevenue: 212000, totalExpenses: 115000, netProfit: 97000 },
                { name: 'Dec', systemRevenue: 220000, totalExpenses: 118000, netProfit: 102000 },
            ];

            setChartData(data);
        } catch (error) {
            console.error('Error fetching superadmin financial data:', error);
            setFallbackData();
        }
    };

    // Community - Community-specific financial data
    const fetchCommunityFinancialData = async () => {
        try {
            const response = await axiosInstance.get(`/api/community/financial/monthly-summary/${communityId}`);

            // Transform API data or use fallback
            const data = response.data?.months || [
                { name: 'Jan', communityRevenue: 25000, communityExpenses: 18000, netBalance: 7000 },
                { name: 'Feb', communityRevenue: 27000, communityExpenses: 19000, netBalance: 8000 },
                { name: 'Mar', communityRevenue: 28000, communityExpenses: 20000, netBalance: 8000 },
                { name: 'Apr', communityRevenue: 30000, communityExpenses: 21000, netBalance: 9000 },
                { name: 'May', communityRevenue: 32000, communityExpenses: 22000, netBalance: 10000 },
                { name: 'Jun', communityRevenue: 35000, communityExpenses: 24000, netBalance: 11000 },
                { name: 'Jul', communityRevenue: 37000, communityExpenses: 25000, netBalance: 12000 },
                { name: 'Aug', communityRevenue: 40000, communityExpenses: 27000, netBalance: 13000 },
                { name: 'Sep', communityRevenue: 42000, communityExpenses: 28000, netBalance: 14000 },
                { name: 'Oct', communityRevenue: 45000, communityExpenses: 30000, netBalance: 15000 },
                { name: 'Nov', communityRevenue: 48000, communityExpenses: 32000, netBalance: 16000 },
                { name: 'Dec', communityRevenue: 50000, communityExpenses: 33000, netBalance: 17000 },
            ];

            setChartData(data);
        } catch (error) {
            console.error('Error fetching community financial data:', error);
            setFallbackData();
        }
    };

    // Sales - Sales performance data
    const fetchSalesFinancialData = async () => {
        try {
            const salesUserId = roleId === 1005 ? clientId : null;
            const response = await axiosInstance.get('/api/sales/monthly-performance', {
                params: { salesUserId }
            });

            // Transform API data or use fallback
            const data = response.data?.months || [
                { name: 'Jan', salesRevenue: 95000, salesTarget: 100000, commission: 9500 },
                { name: 'Feb', salesRevenue: 105000, salesTarget: 110000, commission: 10500 },
                { name: 'Mar', salesRevenue: 112000, salesTarget: 115000, commission: 11200 },
                { name: 'Apr', salesRevenue: 125000, salesTarget: 120000, commission: 12500 },
                { name: 'May', salesRevenue: 118000, salesTarget: 125000, commission: 11800 },
                { name: 'Jun', salesRevenue: 132000, salesTarget: 130000, commission: 13200 },
                { name: 'Jul', salesRevenue: 145000, salesTarget: 140000, commission: 14500 },
                { name: 'Aug', salesRevenue: 138000, salesTarget: 145000, commission: 13800 },
                { name: 'Sep', salesRevenue: 152000, salesTarget: 150000, commission: 15200 },
                { name: 'Oct', salesRevenue: 165000, salesTarget: 160000, commission: 16500 },
                { name: 'Nov', salesRevenue: 158000, salesTarget: 165000, commission: 15800 },
                { name: 'Dec', salesRevenue: 172000, salesTarget: 170000, commission: 17200 },
            ];

            setChartData(data);
        } catch (error) {
            console.error('Error fetching sales financial data:', error);
            setFallbackData();
        }
    };

    // Fallback data based on role
    const setFallbackData = () => {
        if (roleId === 1000) {
            setChartData([
                { name: 'Jan', systemRevenue: 120000, totalExpenses: 80000 },
                { name: 'Feb', systemRevenue: 135000, totalExpenses: 85000 },
                { name: 'Mar', systemRevenue: 142000, totalExpenses: 88000 },
                { name: 'Apr', systemRevenue: 158000, totalExpenses: 92000 },
                { name: 'May', systemRevenue: 165000, totalExpenses: 95000 },
                { name: 'Jun', systemRevenue: 172000, totalExpenses: 98000 },
                { name: 'Jul', systemRevenue: 185000, totalExpenses: 102000 },
                { name: 'Aug', systemRevenue: 192000, totalExpenses: 105000 },
                { name: 'Sep', systemRevenue: 198000, totalExpenses: 108000 },
                { name: 'Oct', systemRevenue: 205000, totalExpenses: 112000 },
                { name: 'Nov', systemRevenue: 212000, totalExpenses: 115000 },
                { name: 'Dec', systemRevenue: 220000, totalExpenses: 118000 },
            ]);
        } else if (roleId === 1001 || roleId === 1002) {
            setChartData([
                { name: 'Jan', communityRevenue: 25000, communityExpenses: 18000 },
                { name: 'Feb', communityRevenue: 27000, communityExpenses: 19000 },
                { name: 'Mar', communityRevenue: 28000, communityExpenses: 20000 },
                { name: 'Apr', communityRevenue: 30000, communityExpenses: 21000 },
                { name: 'May', communityRevenue: 32000, communityExpenses: 22000 },
                { name: 'Jun', communityRevenue: 35000, communityExpenses: 24000 },
                { name: 'Jul', communityRevenue: 37000, communityExpenses: 25000 },
                { name: 'Aug', communityRevenue: 40000, communityExpenses: 27000 },
                { name: 'Sep', communityRevenue: 42000, communityExpenses: 28000 },
                { name: 'Oct', communityRevenue: 45000, communityExpenses: 30000 },
                { name: 'Nov', communityRevenue: 48000, communityExpenses: 32000 },
                { name: 'Dec', communityRevenue: 50000, communityExpenses: 33000 },
            ]);
        } else if (roleId === 1004 || roleId === 1005) {
            setChartData([
                { name: 'Jan', salesRevenue: 95000, salesTarget: 100000 },
                { name: 'Feb', salesRevenue: 105000, salesTarget: 110000 },
                { name: 'Mar', salesRevenue: 112000, salesTarget: 115000 },
                { name: 'Apr', salesRevenue: 125000, salesTarget: 120000 },
                { name: 'May', salesRevenue: 118000, salesTarget: 125000 },
                { name: 'Jun', salesRevenue: 132000, salesTarget: 130000 },
                { name: 'Jul', salesRevenue: 145000, salesTarget: 140000 },
                { name: 'Aug', salesRevenue: 138000, salesTarget: 145000 },
                { name: 'Sep', salesRevenue: 152000, salesTarget: 150000 },
                { name: 'Oct', salesRevenue: 165000, salesTarget: 160000 },
                { name: 'Nov', salesRevenue: 158000, salesTarget: 165000 },
                { name: 'Dec', salesRevenue: 172000, salesTarget: 170000 },
            ]);
        }
    };

    // Get role-specific chart configuration
    const getChartConfig = () => {
        if (roleId === 1000) {
            return {
                bars: [
                    { dataKey: 'systemRevenue', fill: '#4F86C6', name: 'System Revenue' },
                    { dataKey: 'totalExpenses', fill: '#E97451', name: 'Total Expenses' }
                ],
                yAxisFormatter: (value) => windowWidth < 640 ? `${value / 1000}k` : `$${value.toLocaleString()}`
            };
        } else if (roleId === 1001 || roleId === 1002) {
            return {
                bars: [
                    { dataKey: 'communityRevenue', fill: '#4F86C6', name: 'Community Revenue' },
                    { dataKey: 'communityExpenses', fill: '#E97451', name: 'Community Expenses' }
                ],
                yAxisFormatter: (value) => windowWidth < 640 ? `${value / 1000}k` : `$${value.toLocaleString()}`
            };
        } else if (roleId === 1004 || roleId === 1005) {
            return {
                bars: [
                    { dataKey: 'salesRevenue', fill: '#4F86C6', name: 'Sales Revenue' },
                    { dataKey: 'salesTarget', fill: '#E97451', name: 'Sales Target' }
                ],
                yAxisFormatter: (value) => windowWidth < 640 ? `${value / 1000}k` : `$${value.toLocaleString()}`
            };
        }
        return { bars: [], yAxisFormatter: (value) => value };
    };

    // Adaptive margins based on screen size
    const margin = {
        top: 10,
        right: windowWidth < 640 ? 10 : 30,
        left: windowWidth < 640 ? 5 : 20,
        bottom: windowWidth < 640 ? 15 : 5,
    };

    // Custom tooltip to ensure it's readable on small screens
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="bg-white p-2 border border-gray-200 shadow-md rounded text-xs sm:text-sm">
                    <p className="font-semibold">{label}</p>
                    {payload.map((entry, index) => (
                        <p key={index} style={{ color: entry.color }}>
                            {entry.name}: ${entry.value.toLocaleString()}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    const chartConfig = getChartConfig();

    if (loading) {
        return (
            <div className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                    <p className="text-gray-500">Loading financial data...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] flex items-center justify-center">
                <div className="text-center text-red-500">
                    <div className="text-red-500 mb-2">⚠️</div>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px]">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={chartData}
                    margin={margin}
                    barGap={windowWidth < 640 ? 2 : 4}
                    barCategoryGap={windowWidth < 640 ? 8 : 25}
                    barSize={windowWidth < 640 ? 10 : 19}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis
                        dataKey="name"
                        tick={{
                            fontSize: windowWidth < 640 ? 9 : 12,
                            angle: windowWidth < 640 ? -45 : 0,
                            textAnchor: windowWidth < 640 ? 'end' : 'middle'
                        }}
                        height={windowWidth < 640 ? 60 : 30}
                        tickMargin={windowWidth < 640 ? 10 : 5}
                    />
                    <YAxis
                        tick={{ fontSize: windowWidth < 640 ? 10 : 12 }}
                        tickFormatter={chartConfig.yAxisFormatter}
                        width={windowWidth < 640 ? 35 : 60}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                        wrapperStyle={{
                            fontSize: windowWidth < 640 ? 10 : 12,
                            paddingTop: 40
                        }}
                    />
                    {chartConfig.bars.map((bar, index) => (
                        <Bar
                            key={index}
                            dataKey={bar.dataKey}
                            fill={bar.fill}
                            name={bar.name}
                        />
                    ))}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default DashboardChart;